export const INVITES_CSV_HEADING = 'email,name'

export const CSV_PREPEND = `data:text/csv;charset=utf-8,`

export const INVITES_CSV_DEFAULT = `${CSV_PREPEND}${INVITES_CSV_HEADING}`

export const generateEncodedUri = (csvContent: string) =>
  encodeURI(CSV_PREPEND + `${csvContent}`)
